exports.createEnum = (value, label) => ({ value, label });
